import { createMuiTheme } from '@material-ui/core/styles';
import styles from './styles';

const theme = createMuiTheme( styles );

export default theme;
